
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import moment from 'moment';
import type { ZoomColumnInfoInterface, ZoomResultsColumnCellRendererParams } from '@nts/std/interfaces';


// create your cellEditor as a Angular component
@Component({
    template: `
        @if (this.params?.data) {
          <div>
            {{ value }}
          </div>
        } @else {
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        }
        `,
    selector: 'nts-zoom-result-datetime-cell-renderer',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class ZoomResultsDateTimeCellRendererComponent implements AgRendererComponent {
    params: ZoomResultsColumnCellRendererParams;
    private internalValue = null;

    refresh(params: any): boolean {
        return true;
    }
    agInit(params: ZoomResultsColumnCellRendererParams): void {
        this.params = params;
    }

    get value() {
        if (this.internalValue == null) {
            const currentValue = this.params.data[Number.parseInt(this.params.colDef.field)];
            if (currentValue != null) {
                const columnInfo: ZoomColumnInfoInterface = this.params.columnInfo;
                this.internalValue = columnInfo.propertyName === 'creationDate' || columnInfo.propertyName === 'updateDate' ?
                    moment(currentValue).format('L LT') : moment(currentValue).format('L');
            } else this.internalValue = '';
        }
        return this.internalValue;
    }
}
